// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-input input,\n.theme--light.v-input textarea,\n.v-select__selection--comma,\n.theme--light.v-label {\n  color: var(--v-primary-base);\n}\n.v-application .mdi-menu-down,\n.theme--light.v-chip:not(.v-chip--active) {\n  color: var(--v-secondary-base);\n}", ""]);
// Exports
module.exports = exports;
